module.exports = __webpack_public_path__ + "static/media/sound_back.28b91f84.mp3";